import  React from 'react'
export const GlobalContext = React.createContext()
export const GlobalDispatchContext = React.createContext()